import React,{useEffect, useState} from "react";
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Cookies from "js-cookie";
import Swal from 'sweetalert2';
import BaseUrl from '../Components/BaseUrl';


const Onboardingstep2 = () => {
    const navigate =useNavigate();
    useEffect(() => {
        const fname = window.localStorage.getItem("fname") || "";
        const lname = window.localStorage.getItem("lname") || "";
        
        setFormData(prevState => ({
            ...prevState, 
            fname,
            lname
        }));
    }, []);
    
    const [formData, setFormData] = useState({
      fname: "",
      lname:"",
      country:"",
      city:""
    });
    const [error, setError] = useState({
        country:"",
        city:""
    })

    const handleChange = (e) => {
        const {id,value}=e.target;
        setFormData({...formData,[id]:value})
        setError({...error,[id]:""})
    }
    const validateForm = () => {
        let isValid = true;
        let errors = {};
        if (formData.country.trim() === "") {
            errors.country = "Country is required";
            isValid = false;
        }
        if (formData.city.trim() === "") {
            errors.city = "City is required";
            isValid = false;
        }
        setError(errors);  
        return isValid;  
    };
    
    const handleSubmit=async(e)=>{
        e.preventDefault();
        const result=validateForm();
        const user_id = Cookies.get("user_id");
        const requestdata={
            name :`${formData.fname} ${formData.lname}`,
            country:formData.country,
            city:formData.city
        }
        if(result){
            try {
                const response = await axios.post(
                  BaseUrl + "onboarding/step2",
                  requestdata,
                  {
                    headers: {
                      "user-id": user_id,
                    },
                  }
                );
                if(response.status===200){
                    window.localStorage.removeItem("fname");                    
                    window.localStorage.removeItem("lname");
                      setFormData({
                        fname: "",
                        lname:"",
                        country:"",
                        city:""
                      });
                    setTimeout(() => {
                        navigate("/user/onboarding/step3")
                    }, 100);
            }
            
        }
        catch (error) {
            console.log(error)
        }
    }
    }
    
  return (
    <>
      <div className="flex flex-col items-center mt-12 mb-4 justify-start min-h-screen bg-[#F3F2EF] py-10 px-4 sm:px-6 lg:px-8">
        <div className="mt-6">
          <p className="text-3xl  mb-2 text-center">
            {" "}
            Welcome, {formData.fname}! What's your location?
          </p>
          <p className="text-sm mb-4 text-gray-500 text-center">
            see people, jobs and news in your area
          </p>
        </div>
        <div className="w-full max-w-md">
          <form className="bg-white p-8 rounded-lg shadow-xl ">
            <label
              className="block text-gray-700 text-sm font-bold mb-1"
              htmlFor="name"
            >
              Location<span className="text-red-500">*</span>
            </label>
            <div className="mb-4">
              {/* <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                Country <span className="text-red-500">*</span>
              </label> */}
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="country"
                value={formData.country}
                onChange={handleChange}
                type="text"
                placeholder="Country"
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.country}
              </span>
            </div>

            <div className="mb-4">
              {/* <label
                className="block text-gray-700 text-sm font-bold mb-1"
                htmlFor="name"
              >
                City <span className="text-red-500">*</span>
              </label> */}
              <input
                className="shadow appearance-none border rounded-md h-10 w-full py-2 px-2 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                id="city"
                value={formData.city}
                onChange={handleChange}
                type="text"
                placeholder="City "
              />
              <span className="text-red-500 ml-1 text-sm mb-1">
                {error.city}
              </span>
            </div>

            <div className=" mt-8 flex flex-col items-center">
              <button
                className="bg-[#0A66C2] hover:bg-blue-700 text-white text-LG font-bold py-2 px-4 h-12 rounded-full w-full"
                type="button"
                onClick={handleSubmit}
              >
                Next
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default Onboardingstep2;
